import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Textfield from '@atlaskit/textfield';
export var EditNumber = function EditNumber(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label,
    jiraField = _ref.jiraField;
  // Since Jira adds .0 to the end of the number, we will omit it.
  // But we will still allow the user to fill out .0 themselves
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    userHasEdited = _useState2[0],
    setUserHasEdited = _useState2[1];
  return /*#__PURE__*/React.createElement(Textfield, _extends({
    id: id,
    value: jiraField && !userHasEdited ? value === null || value === void 0 ? void 0 : value.replace(/\.0$/, '') : value,
    isInvalid: isInvalid,
    isRequired: isRequired,
    onChange: onChange,
    onInput: function onInput() {
      return setUserHasEdited(true);
    },
    width: "small",
    label: label,
    "aria-label": label,
    title: label,
    placeholder: ""
  }, isInvalid && errorId && fg('jsm-accessibility-fixes') ? {
    'aria-describedby': errorId
  } : {}));
};